import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import {
  Button,
  Divider,
  Form,
  Grid,
  Icon,
  Accordion,
  Checkbox,
} from 'semantic-ui-react';

import { GenericFiltersContainer } from 'Components/filters/container';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { PrintBarcodeEnum } from 'Common/FieldEnum';
import { CK_PRINT_BARCODES_FORM_NAME } from 'Common/FormEnum';
import { PrintSortTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';

import ItemListContainer from './../containers/ItemListContainer';

const PrintBarcodesComponent = props => {
  const {
    fields,
    handleChange,
    filterValues,
    clearFilters,
    sortOptionsValue,
    itemListData,
    setSortByOption,
    activeIndexes,
    handleClick,
    onSortedChange,
    onFilteredChange,
    sorted,
    filtered,
    reactTableRef,
    loading,
    setItemsWithoutUPC,
    toggleSelected,
    sortOptions,
  } = props;

  return (
    <Fragment>
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={activeIndexes.indexOf(0) !== -1}
            index={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={activeIndexes.indexOf(0) !== -1}>
            <Grid className="grid-spacing">
              <GenericFiltersContainer
                fields={fields}
                onChange={handleChange}
                filterValues={filterValues}
              />
              <Grid.Row columns={2}>
                <Grid.Column width={8} style={{ marginTop: '45px' }}>
                  <Checkbox
                    label="Include Items Without UPC"
                    toggle
                    name={PrintBarcodeEnum.CurrentUpcItems}
                    checked={toggleSelected}
                    onChange={(e, data) => {
                      setItemsWithoutUPC(e, data.checked);
                    }}
                  />
                </Grid.Column>
                <Grid.Column
                  width={8}
                  textAlign={'right'}
                  style={{ marginTop: 45 }}
                  floated={'right'}
                >
                  <Button
                    className={'clear-filters-button'}
                    content="Clear Filters"
                    onClick={clearFilters}
                    type={'button'}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Accordion fluid styled>
          <Accordion.Title
            active={activeIndexes.indexOf(1) !== -1}
            index={1}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Sort By</span>
          </Accordion.Title>
          <Accordion.Content active={activeIndexes.indexOf(1) !== -1}>
            <ReduxFormButtonGroup
              options={sortOptions}
              value={sortOptionsValue}
              formName={CK_PRINT_BARCODES_FORM_NAME}
              fieldName={PrintBarcodeEnum.SortOptions}
              type={'button'}
              onChange={setSortByOption}
            />
          </Accordion.Content>
        </Accordion>
        <Divider horizontal />
        <Grid>
          <Grid.Row columns={1} className={'remove-spacing'}>
            <Grid.Column>
              <Field
                component={ItemListContainer}
                name={PrintBarcodeEnum.ItemListInfo}
                {...{
                  itemListData,
                  onSortedChange,
                  onFilteredChange,
                  sorted,
                  filtered,
                  reactTableRef,
                  loading,
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </Fragment>
  );
};

PrintBarcodesComponent.propTypes = {
  fields: PropTypes.array.isRequired,
  filterValues: PropTypes.object.isRequired,
  itemListData: PropTypes.array,
  handleChange: PropTypes.func,
  clearFilters: PropTypes.func,
  setSortByOption: PropTypes.func,
  onSortedChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  handleClick: PropTypes.func,
  sortOptionsValue: PropTypes.number,
  activeIndexes: PropTypes.array,
  sorted: PropTypes.array,
  filtered: PropTypes.array,
  reactTableRef: PropTypes.object,
  loading: PropTypes.bool,
  setItemsWithoutUPC: PropTypes.func,
  toggleSelected: PropTypes.bool,
  sortOptions: PropTypes.array,
};

PrintBarcodesComponent.defaultProps = {
  itemListData: [],
  handleChange: () => {},
  clearFilters: () => {},
  setSortByOption: () => {},
  onSortedChange: () => {},
  onFilteredChange: () => {},
  sortOptionsValue: PrintSortTypeEnum.ItemCode,
  activeIndexes: [],
  sorted: [],
  filtered: [],
  reactTableRef: null,
  loading: false,
  setItemsWithoutUPC: () => {},
  toggleSelected: false,
  sortOptions: [],
};

export default PrintBarcodesComponent;



// WEBPACK FOOTER //
// ./src/pages/utilities/printbarcodes/components/PrintBarcodesComponent.js